/**
 * Which groups and folders of the rail are open, kept on the device (`fold.ts`). The computer's rail and the phone's
 * and iPad's groups read it, so a group closed on one stays closed on the other.
 */
import { useEffect, useState } from "react";
import type { LibraryAsset, LibraryFolder } from "../../shared/types";
import { type GroupKey, groupOpen, loadFold, revealFolder, saveFold, toggleFolder, toggleGroup } from "./fold";
import { ALL, groupFolders, groupHits, ownFolders } from "./library";

export function useRailFold(folders: LibraryFolder[], assets: LibraryAsset[], q: string, folder: string) {
  const [fold, setFold] = useState(loadFold);
  const hits = groupHits(folders, assets, q);
  const own = ownFolders(folders);
  const sizes: Record<GroupKey, number> = {
    Folders: own.filter((f) => f.parent_id === null).length,
    Flashkut: groupFolders(folders, "Flashkut").length,
    Flashroom: groupFolders(folders, "Flashroom").length,
  };
  useEffect(() => {
    if (folder && folder !== ALL) setFold((was) => revealFolder(was, folders, folder));
  }, [folders, folder]);
  useEffect(() => saveFold(fold), [fold]);
  return {
    fold,
    own,
    sizes,
    isOpen: (g: GroupKey) => groupOpen(fold, g, sizes[g], hits[g]),
    toggle: (g: GroupKey) => setFold((was) => toggleGroup(was, g, sizes[g], hits[g])),
    toggleKid: (id: string) => setFold((was) => toggleFolder(was, id)),
  };
}
